import { ListGroupItem } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

interface IProps {
    editLink: string,
    alias: string,
    rowNumber: number,
    issues: string[],
    target?: string
}

const ComplianceIssueList = (props: IProps) => {
    const { editLink, alias, rowNumber, issues, target } = props;

    return (
        <ListGroupItem>
            <span>{rowNumber}.&nbsp;</span>
            <a className='normal' href={editLink} target={target}>{alias}</a> is missing the following information:
            <ul style={{ marginBottom: 0 }}>
                {issues.map((issue, issueIndex) =>
                    <li key={alias + '-issue-' + issueIndex}>{ReactHtmlParser(issue)}</li>
                )}
            </ul>
        </ListGroupItem>
    );
}

export default ComplianceIssueList;